module.exports = require("vuetify/lib/components/VDialog");